import * as React from 'react'

import Panel from './Panel'
import Tab from './Tab'
import * as styles from './index.vanilla.css'
import { TabType } from './types'

interface Props<TabIds> {
  selectedTab?: TabType<TabIds>
  tabs: Array<TabType<TabIds>>
  // FIXME will change when we come up with a new solution for modifying common components
  marginLeft?: boolean
  onClick?: (selectedTab: TabType<TabIds>) => void
}
interface State<TabIds> {
  selectedTab: TabType<TabIds> | null | undefined
}

interface ChildrenProps<TabIds> {
  tab: TabType<TabIds>
  isSelected: boolean
}
class Tabs<TabIds> extends React.Component<
  Props<TabIds> & React.ConsumerProps<ChildrenProps<TabIds>>,
  State<TabIds>
> {
  static Panel = Panel
  state = {
    selectedTab: null,
  }

  isSelected(tab: TabType<TabIds>): boolean {
    const { tabs, selectedTab: selected } = this.props
    const { selectedTab } = this.state

    return (selected || selectedTab || tabs[0]!).id === tab.id
  }

  handleClick = (selectedTab: TabType<TabIds>) => {
    this.setState({
      selectedTab,
    })
    this.props.onClick && this.props.onClick(selectedTab)
  }

  render() {
    const { tabs, children, marginLeft } = this.props

    return (
      <>
        <div className={`${styles.tabs} ${marginLeft ? 'marginLeft' : ''}`} role="tablist">
          {tabs.map((tab) => (
            <Tab
              tab={tab}
              isSelected={this.isSelected(tab)}
              onClick={this.handleClick}
              key={`tab_${tab.id}`}
            />
          ))}
        </div>
        {tabs.map((tab) => children({ tab, isSelected: this.isSelected(tab) }))}
      </>
    )
  }
}

export default Tabs
